import { render, staticRenderFns } from "./Textures.vue?vue&type=template&id=01d922de&"
import script from "./Textures.vue?vue&type=script&lang=js&"
export * from "./Textures.vue?vue&type=script&lang=js&"
import style0 from "./Textures.vue?vue&type=style&index=0&id=01d922de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports